import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as realinfoActions from '../../../actions/realinfo';
import { EMAIL_VERIFICATION_AGE_TO_UPDATE_REALINFO } from '../../../constants';
import ErrorMsg from '../../common_components/ErrorMsg';

class Realinfo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			emailError: null,
		};
	}

	handleClickLink() {
		this.props.initRealinfo();
	}
	handleClickChange() {
		this.setState({ emailError: null });
		var now = Math.floor(Date.now() / 1000);
		if (
			!this.props.userInfo.email_v ||
			now - this.props.userInfo.email_verified_time <
				EMAIL_VERIFICATION_AGE_TO_UPDATE_REALINFO
		) {
			this.setState({
				emailError: trans('error_email_not_verified_30_days'),
			});
		} else {
			this.props.initUpdateRealinfo();
		}
	}

	renderPCIcon() {
		if (this.props.userInfo.realname) {
			return (
				<div className="securityhome-item__icon securityhome-item__icon--yellow securityhome-item__icon--realinfo"></div>
			);
		} else {
			return (
				<div className="securityhome-item__icon securityhome-item__icon--gray securityhome-item__icon--realinfo"></div>
			);
		}
	}

	renderMobileIcon() {
		if (this.props.userInfo.realname) {
			return (
				<div className="securityhome-item__name-icon securityhome-item__name-icon--yellow securityhome-item__name-icon--realinfo"></div>
			);
		} else {
			return (
				<div className="securityhome-item__name-icon securityhome-item__name-icon--gray securityhome-item__name-icon--realinfo"></div>
			);
		}
	}

	renderText() {
		return (
			<div className="securityhome-item__txt">
				<div className="securityhome-item__name">
					{this.renderMobileIcon()}
					<span className="securityhome-item__rname">
						{trans('Name_and_ID_card_number')}
					</span>
				</div>
				{this.props.userInfo.realname ? (
					<div>
						<div className="securityhome-item__desc">
							{trans('Name')}: {this.props.userInfo.realname}
						</div>
						<div className="securityhome-item__desc">
							{trans('ID_Card_Number')}:{' '}
							{this.props.userInfo.idcard}
						</div>
					</div>
				) : (
					<div className="securityhome-item__desc">
						{trans('real_info_hint')}
					</div>
				)}
			</div>
		);
	}

	renderTitle() {
		if (this.props.userInfo.realname) {
			return (
				<div className="securityhome-item__name">
					{this.renderMobileIcon()}
					<span className="securityhome-item__valname">
						{trans('ID_Card_Number')}:{' '}
					</span>
					<span className="securityhome-item__val">
						{this.props.userInfo.idcard}
					</span>
				</div>
			);
		} else {
			return (
				<div className="securityhome-item__name">
					{this.renderMobileIcon()}
					<span className="securityhome-item__valname">
						{trans('ID_Card_Number')}
					</span>
					{isMobile ? (
						<span className="securityhome-item__val">
							{trans('ID_Card_Number')}
						</span>
					) : null}
				</div>
			);
		}
	}

	renderAction() {
		if (this.props.userInfo.realname) {
			if (this.props.userInfo.realinfo_updatable) {
				return (
					<div className="securityhome-item__op">
						<a
							href="#"
							className="securityhome-item__link"
							onClick={this.handleClickChange.bind(this)}
						>
							{trans('change_action')}
						</a>
					</div>
				);
			}
		} else {
			return (
				<div className="securityhome-item__op">
					<a
						href="#"
						className="securityhome-item__link"
						onClick={this.handleClickLink.bind(this)}
					>
						{trans('Link')}
					</a>
				</div>
			);
		}
	}

	renderError() {
		return <ErrorMsg error_msg={this.state.emailError} />;
	}

	render() {
		return (
			<div className="securityhome-item">
				{this.renderPCIcon()}
				<div className="securityhome-item__txt">
					{this.renderTitle()}
					<div className="securityhome-item__desc">
						{trans('real_info_hint')}
					</div>
					{this.renderError()}
				</div>
				{this.renderAction()}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, realinfoActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Realinfo);



// WEBPACK FOOTER //
// ./app/components/security/main_panel/Realinfo.js